export const adminSupportTeamParam = "supportTeam";
export function getAdminSupportTeamId() {
    return new URLSearchParams(window.location.search).get(adminSupportTeamParam)?.trim() ?? "";
}
export function adminSupportTeamUrl(teamId) {
    const parameters = new URLSearchParams({ [adminSupportTeamParam]: teamId });
    return `/?${parameters.toString()}`;
}
